export { ConferenceBoothMobileInfo } from './ConferenceBoothMobileInfo';
